import { ColumnType, ViewType } from '@thehubz/client/core';
import { AssetRelation, RelationshipType } from '@thehubz/client/data-access-api';
import { split } from '../../assets/assets-page.util';
import { GroupedAssetRelations } from './asset-relations.models';

/**
 * Group the asset relations by relationship type.
 */
export function groupAssetRelationsByRelationshipType(assetRelations: AssetRelation[], viewType: ViewType): GroupedAssetRelations[] {
  const groupedRelations: GroupedAssetRelations[] = [];

  assetRelations.forEach((relation) => {
    const relationshipType = relation.relationshipType as RelationshipType;
    const existingGroup = groupedRelations.find((group) => group.relationshipType === relationshipType.name);

    if (!relation.relatedAsset) {
      return;
    }

    if (existingGroup) {
      existingGroup.relatedAssets.push(relation.relatedAsset);
    } else {
      groupedRelations.push({
        relationshipType: relationshipType.name,
        relatedAssets: [relation.relatedAsset],
        splitRelatedAssets: [],
      });
    }
  });

  const gridSize = parseInt(viewType.replace('grid_', ''));
  groupedRelations.forEach((group) => {
    const multiDimensionAsset = split(group.relatedAssets, gridSize);
    group.splitRelatedAssets = multiDimensionAsset;
  });

  return groupedRelations;
}

export function getRelationTypeColumnDef() {
  return {
    sequence: 3,
    columnDef: 'relationType',
    header: $localize`Relations Type`,
    class: 'w-[10%] min-w-[10rem] pl-4',
    filter: false,
    filterSelected: 0,
    visible: true,
    columnType: 'default' as ColumnType,
  };
}
